export default "__VITE_ASSET__DFhfO8js__"